import { createSlice } from "@reduxjs/toolkit";
import { batchesApi } from "../services/batchesApi";

const initialState = {
    data: [],
};

export const batchSlice = createSlice({
    name: "batch",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addMatcher(
                batchesApi.endpoints.getBatchByTrainingId.matchFulfilled,
                (state, { payload }) => {
                    state.data = payload.data;
                }
            )
            .addMatcher(
                batchesApi.endpoints.getBatchByTrainingId.matchRejected,
                (state, { payload }) => {
                    state.data = [];
                }
            );
        builder
            .addMatcher(
                batchesApi.endpoints.enrollBatch.matchFulfilled,
                (state, { payload, meta }) => {
                    const params = meta.arg.originalArgs || {}

                    state.data = state?.data?.map(item => {
                        if (item.id !== params.batch_id) return item;
                        return {
                            ...item,
                            is_enrolled: 1
                        }
                    })
                }
            )
            .addMatcher(
                batchesApi.endpoints.enrollBatch.matchRejected,
                (state, { payload }) => { }
            );
    },
});

export const { } = batchSlice.actions;

export default batchSlice.reducer;
